export default __webpack_public_path__ + "static/media/logout_icon.62980e02.svg";